module.exports = __webpack_public_path__ + "static/media/0.040c7846.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/buy/0.png
// module id = 967
// module chunks = 0